import { useCallback } from "react";
import { useExploreImage } from "../ExploreImageContext";
import { MAX_REGIONS } from "../regionColors";
import type { Region } from "../types";

export function useImageRegions() {
  const {
    state,
    setRegions,
    addRegion: addRegionToContext,
    updateRegion,
    removeRegion,
  } = useExploreImage();
  const { regions } = state;

  const resetRegions = useCallback(() => {
    setRegions(regions.length > 0 ? [regions[0]] : []);
  }, [setRegions, regions]);

  const canAddRegion = regions.length < MAX_REGIONS;

  // Delegate to the reducer so the length check and append happen atomically;
  // closing over `regions` here would let two rapid draw-end events both pass
  // the length check against the same stale snapshot and drop one region.
  const addRegion = useCallback(
    (region: Region) => {
      addRegionToContext(region, MAX_REGIONS);
    },
    [addRegionToContext],
  );

  return {
    regions,
    updateRegion,
    removeRegion,
    addRegion,
    resetRegions,
    canAddRegion,
  };
}
